export default (axios, value) => axios.get(`/check-promocode/${value}`);
